<!-- Material Symbols Outlined (default) -->
<span
  *ngIf="!useMatIcon && !outlined"
  class="material-symbols-outlined cdw-icon"
  [ngClass]="{ 'cdw-icon-filled': fill }"
  [style.color]="customColor"
  [style.font-size]="size"
  >{{ icon }}</span
>

<!-- Material Icons Outlined (when outlined is true) -->
<span
  *ngIf="!useMatIcon && outlined"
  class="material-icons-outlined cdw-icon"
  [style.color]="customColor"
  [style.font-size]="size"
>{{
  icon
}}</span>

<!-- Mat Icon (when useMatIcon is true) -->
<mat-icon *ngIf="useMatIcon" [style.color]="customColor" [style.font-size]="size">{{ icon }}</mat-icon>
